import DetailPoints from "../DetailPoints";
import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointRavgdt = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };

  return (
    <>
      {context.state["Carriere" + ClientConjoint].filter((Carriere) => Carriere.Nature === "RsiCommercant").length > 0 && (
        <div className="card">
          <div className="category-column">
            <label className="prise-en-charge-cell-label" style={{ marginBottom: 0 }}>
              RAVGDT
            </label>
          </div>
          <div className="value-column">
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteCompRavgdt}
              onChange={(e) => {
                context.handlePointRetraite(ClientConjoint, "RetraiteCompRavgdt", e);
              }}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
          </div>
          <div className="value-column">
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinRavgdtComp}
              onChange={(e) => {
                context.handlePointRetraite(ClientConjoint, "AnneeFinRavgdtComp", e);
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={resultRetraite?.InfosRetraite?.Ravgdt?.General?.PointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.Ravgdt?.General?.PointCalcule}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
            <DetailPoints caisse="Ravgdt" regime="Complementaire" champ="PointCalcule" libelle="RAVGDT" />
          </div>
        </div>
      )}
    </>
  );
};
export default PointRavgdt;
